"use strict";
/**
 * Types for the RAG (Retrieval-Augmented Generation) system
 */

// Export QueryType enum
export var QueryType;
(function (QueryType) {
    QueryType["GENERAL"] = "general";
    QueryType["TECHNIQUE"] = "technique";
    QueryType["PAYLOAD"] = "payload";
    QueryType["TOOL"] = "tool";
    QueryType["WAF_BYPASS"] = "waf_bypass";
})(QueryType || (QueryType = {}));

// Also export as a regular object for better compatibility
export const QueryTypeObj = {
    GENERAL: 'general',
    TECHNIQUE: 'technique',
    PAYLOAD: 'payload',
    TOOL: 'tool',
    WAF_BYPASS: 'waf_bypass'
};

// Export a default object with all exports
export default {
    QueryType,
    QueryTypeObj
};
